export default __webpack_public_path__ + "static/iotex-84c8822e410d69632f567bc49d74b42d.svg";